module.exports = __webpack_public_path__ + "img/twitter.88c38bdc.svg";